import {useContext, useEffect, useState} from "react";
import {DatePicker} from 'react-advance-jalaali-datepicker'
import FormFooter from "../../components/FormFooter";
import {MyContext} from "../../context/myContext";
import moment from "moment-jalaali";
import {useDispatch, useSelector} from "react-redux";
import {selectShowForm, selectRegisterBtnType, selectAllCities} from "../common-states/commonStatesSlice";
import {addOrEditNomad, selectInputsState, selectSelectsState} from "./applicantSlice";

const AddApplicantForm = () => {
    const {nomadId} = useContext(MyContext)
    const initialInputState = {
        fatherName: '', name: '', birthday: '', code: '', phone: '', mobile: '', distance: '',
        family: '', insuredLiveStock: '', liveStock: '', nomadicArea: '', waterVolume: '', membershipNumber: ''
    }
    const initialSelectsState = {city: '', province: 'خراسان جنوبی', tank: '', registrationType: ''}
    const [inputs, setInputs] = useState(initialInputState);
    const [selects, setSelects] = useState(initialSelectsState)
    const dispatch = useDispatch()
    const registerBtnType = useSelector(selectRegisterBtnType)
    const showForm = useSelector(selectShowForm)
    const inputsState = useSelector(selectInputsState)
    const selectsState = useSelector(selectSelectsState)
    const allCities = useSelector(selectAllCities)

    useEffect(() => {
        if(inputsState !== null && selectsState !== null){
            setInputs(inputsState)
            setSelects(selectsState)
        }
    }, [inputsState, selectsState])

    const handleInputChange = (e) => {
        let name = e.target.name;
        setInputs({...inputs, [name]: e.target.value})
    }
    const handleSelectChange = (e) => {
        let name = e.target.name;
        setSelects({...selects, [name]: e.target.value})
    }
    const handleDateChange = (timestamp, newDate) => {
        console.log(newDate)
        setInputs({...inputs, birthday: newDate})
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        let birthday = moment(inputs.birthday, 'jYYYY/jM/jD').format('YYYY/MM/DD')
        let commonData = {
            authentication_id: selects.registrationType === 'مورد تایید رئیس' ? null : inputs.membershipNumber,
            authentication_type: selects.registrationType === 'مورد تایید رئیس' ? 1 : 0,
            city_id: selects.city,
            dewatering_to_evacuation_distance: inputs.distance ? inputs.distance : null,
            insured_livestock_count: inputs.insuredLiveStock ? inputs.insuredLiveStock : null,
            livestock_count: inputs.liveStock,
            mobiles: [{mobile: inputs.mobile}],
            name: inputs.name,
            father_name: inputs.fatherName ? inputs.fatherName : null,
            national_code: inputs.code,
            population: inputs.family,
            region: inputs.nomadicArea,
            user_id: localStorage.getItem('userId'),
            water_storage_type: selects.tank === 'تانکر' ? 0 : selects.tank === 'آب انبار' ? 1 : 2,
            water_volume: inputs.waterVolume
        };
        if(inputs.phone){
            commonData.mobiles[1] = {mobile: inputs.phone}
        }
        const data = {...commonData, birthday: birthday, created_at: new Date().toISOString(),}
        dispatch(addOrEditNomad({data, commonData, nomadId, dispatch, registerBtnType})) //data is for add nomad, commonData and nomadId is for edit nomad
    }
    const validateNumber = (event) => { //to prevent typing alphabet inside inputs that needs numbers
        const keyCode = event.keyCode;
        const excludedKeys = [8, 37, 39, 46];
        if (!((keyCode >= 48 && keyCode <= 57) ||
            (keyCode >= 96 && keyCode <= 105) ||
            (excludedKeys.includes(keyCode)))) {
            event.preventDefault();
        }
    }

    useEffect(() => {
        setInputs(initialInputState)
        setSelects(initialSelectsState)
        // eslint-disable-next-line
    }, [showForm === false])

    return(
        <form className='add-applicant-form' onSubmit={handleSubmit}>
            <div className='form-grid'>
                <div>
                    <input type='text' name='fatherName' value={inputs.fatherName} placeholder='نام پدر' onChange={handleInputChange} />
                    {inputs.fatherName !== '' && <i>نام پدر</i>}
                </div>
                <div>
                    <input type='text' name='name' value={inputs.name} placeholder='نام و نام خانوادگی' onChange={handleInputChange} required />
                    {inputs.name !== '' && <i>نام</i>}
                    <span>*</span>
                </div>
                <div>
                    <DatePicker format="jYYYY/jMM/jDD" inputTextAlign='center' controlValue={true} preSelected={inputs.birthday} onChange={handleDateChange} customClass='datepicker' placeholder={'تاریخ تولد'} />
                    {inputs.birthday !== '' && <i>تاریخ تولد</i>}
                </div>
                <div>
                    <input type='text' name='code' onKeyDown={validateNumber} pattern='[0-9]{10}' value={inputs.code} placeholder='کد ملی(ده رقم)' onChange={handleInputChange} required />
                    {inputs.code !== '' && <i>کد ملی</i>}
                    <span>*</span>
                </div>
                <div>
                    <input type='tel' name='phone' onKeyDown={validateNumber} pattern='056[0-9]{8}' value={inputs.phone} placeholder='تلفن ضروری(056)' onChange={handleInputChange} />
                    {inputs.phone !== '' && <i>تلفن</i>}
                </div>
                <div>
                    <input type='tel' name='mobile' onKeyDown={validateNumber} pattern='09[0-9]{9}' value={inputs.mobile} placeholder='تلفن همراه' onChange={handleInputChange} required />
                    {inputs.mobile !== '' && <i>همراه</i>}
                    <span>*</span>
                </div>
                <div>
                    <input type='text' name='distance' onKeyDown={validateNumber} value={inputs.distance} placeholder='فاصله آبگیری تا تخلیه(کیلومتر)' onChange={handleInputChange} />
                    {inputs.distance !== '' && <i>کیلومتر</i>}
                </div>
                <div>
                    <input type='text' name='family' onKeyDown={validateNumber} value={inputs.family} placeholder='تعداد خانوار بهره مند' onChange={handleInputChange} required />
                    {inputs.family !== '' && <i>خانوار</i>}
                    <span>*</span>
                </div>
                <div>
                    <input type='text' name='insuredLiveStock' onKeyDown={validateNumber} value={inputs.insuredLiveStock} placeholder='تعداد دام بیمه شده' onChange={handleInputChange} />
                    {inputs.insuredLiveStock !== '' && <i>دام بیمه شده</i>}
                </div>
                <div>
                    <input type='text' name='liveStock' onKeyDown={validateNumber} value={inputs?.liveStock} placeholder='تعدا دام ها' onChange={handleInputChange} required />
                    {inputs.liveStock !== '' && <i>دام</i>}
                    <span>*</span>
                </div>
                <div>
                    <select name='city' value={selects.city} onChange={handleSelectChange} required>
                        <option value='' disabled>انتخاب شهر</option>
                        {allCities?.map((item, index) => {
                            return <option key={index} value={item.city_id}>{item.name}</option>
                        })}
                    </select>
                    <span>*</span>
                </div>
                <div>
                    <select name='province' onChange={handleSelectChange} value={selects.province} required>
                        <option disabled>انتخاب استان</option>
                        <option value='خراسان جنوبی'>خراسان جنوبی</option>
                    </select>
                    <span>*</span>
                </div>
                <div>
                    <select name='tank' value={selects.tank} onChange={handleSelectChange} required>
                        <option value='' disabled>انتخاب نوع مخزن</option>
                        <option value='تانکر'>تانکر</option>
                        <option value='آب انبار'>آب انبار</option>
                        <option value='استخر'>استخر</option>
                    </select>
                    <span>*</span>
                </div>
                <div>
                    <input type='text' name='nomadicArea' value={inputs.nomadicArea} placeholder='منطقه عشایری' onChange={handleInputChange} required />
                    {inputs.nomadicArea !== '' && <i>منطقه عشایری</i>}
                    <span>*</span>
                </div>
                <div>
                    <select name='registrationType' value={selects.registrationType} onChange={handleSelectChange} required>
                        <option value='' disabled>انتخاب نوع ثبت نام</option>
                        <option value='عضویت در تعاونی'>عضویت در تعاونی</option>
                        <option value='مورد تایید رئیس'>مورد تایید رئیس</option>
                    </select>
                    <span>*</span>
                </div>
                <div>
                    <input type='text' name='waterVolume' onKeyDown={validateNumber} value={inputs.waterVolume} placeholder='حجم آب مورد تقاضا(لیتر)' onChange={handleInputChange} required />
                    {inputs.waterVolume !== '' && <i>لیتر</i>}
                    <span>*</span>
                </div>
                {selects?.registrationType === 'عضویت در تعاونی' ?
                    <div className='membership-number-box'>
                        <input type='text' name='membershipNumber' placeholder='شماره عضویت' onKeyDown={validateNumber} value={inputs.membershipNumber} onChange={handleInputChange} required />
                        {inputs.membershipNumber !== '' && <i>شماره عضویت</i>}
                        <span>*</span>
                    </div> :
                    null
                }
            </div>
            <FormFooter />
        </form>
    )
}

export default AddApplicantForm